"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _runtime = require("@preact/signals-react/runtime");

var _signalsReact = require("@preact/signals-react");

var _SttCkEditor = _interopRequireDefault(require("./SttCkEditor"));

var _excluded = ["data", "name", "onChange", "onReady", "atalhos"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SttExamesCkEditor = function SttExamesCkEditor(_ref) {
  var data = _ref.data,
      name = _ref.name,
      _ref$onChange = _ref.onChange,
      _onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _onReady = _ref.onReady,
      _ref$atalhos = _ref.atalhos,
      atalhos = _ref$atalhos === void 0 ? [] : _ref$atalhos,
      others = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(atalhos.map(function (atalho) {
    return {
      id: "#".concat(atalho.atalho),
      text: atalho.descricao
    };
  })),
      _useState2 = _slicedToArray(_useState, 1),
      mentionFeed = _useState2[0];

  (0, _runtime.useSignals)();
  var findResults = (0, _runtime.useSignal)([]);
  var findPosition = (0, _runtime.useSignal)(0);
  var selectionMode = (0, _runtime.useSignal)(false);
  var editorRef = (0, _react.useRef)();
  (0, _runtime.useSignalEffect)(function () {
    if (selectionMode.value && findResults.value.length) {
      var _findResults$value$fi = findResults.value[findPosition.value].marker._liveRange,
          end = _findResults$value$fi.end,
          start = _findResults$value$fi.start; // Obtém os nós de início e fim

      var startPosition = editorRef.current.model.createPositionAt(start, 0);
      var endPosition = editorRef.current.model.createPositionAt(end, 0); // Cria um novo intervalo de seleção

      var newRange = editorRef.current.model.createRange(startPosition, endPosition);
      var selection = editorRef.current.model.createSelection(newRange);
      editorRef.current.model.change(function (writer) {
        writer.setSelection(selection);
      });
    }
  });
  return /*#__PURE__*/_react["default"].createElement(_SttCkEditor["default"], _extends({
    height: 300,
    data: data,
    onChange: function onChange(event, editor) {
      (0, _signalsReact.batch)(function () {
        selectionMode.value = false;
        findResults.value = [];
        findPosition.value = 0;
      });

      _onChange(event, editor);
    },
    onReady: function onReady(editor) {
      editorRef.current = editor;
      editor.keystrokes.set('tab', function (keyEvtData, callback) {
        if (!selectionMode.value) {
          var found = editor.execute('find', '__');
          (0, _signalsReact.batch)(function () {
            selectionMode.value = true;
            findResults.value = found.results._items;
            findPosition.value = 0;
          });
        } else {
          editor.execute('findNext');

          if (findPosition.value === findResults.value.length - 1) {
            findPosition.value = 0;
          } else {
            findPosition.value += 1;
          }
        }

        callback();
      });
      editor.keystrokes.set('Shift+tab', function (keyEvtData, callback) {
        if (!selectionMode.value) {
          var found = editor.execute('find', '__');
          (0, _signalsReact.batch)(function () {
            selectionMode.value = true;
            findResults.value = found.results._items;
            findPosition.value = 0;
          });
        } else {
          editor.execute('findPrevious');

          if (findPosition.value === 0) {
            findPosition.value = findResults.value.length - 1;
          } else {
            findPosition.value -= 1;
          }
        }

        callback();
      });
      editor.editing.view.document.on('selectionChange', function (event, data) {
        (0, _signalsReact.batch)(function () {
          selectionMode.value = false;
          findResults.value = [];
          findPosition.value = 0;
        });
      });

      if (_onReady) {
        _onReady(editor);
      }
    },
    atalhos: atalhos,
    mention: mentionFeed,
    allowImage: true,
    useBase64Adapter: true
  }, others));
};

var _default = SttExamesCkEditor;
exports["default"] = _default;